import { Route } from '@angular/router';
import { initialDataResolver } from 'app/app.resolvers';
import { AuthGuard } from 'app/core/auth/guards/auth.guard';
import { NoAuthGuard } from 'app/core/auth/guards/noAuth.guard';
import { LayoutComponent } from 'app/layout/layout.component';
import { AddProductComponent } from './modules/admin/components/products/add-product/add-product.component';
import { EditProductComponent } from './modules/admin/components/products/edit-product/edit-product.component';
import { AddUnitComponent } from './modules/admin/components/units/add-unit/add-unit.component';
import { EditUnitComponent } from './modules/admin/components/units/edit-unit/edit-unit.component';
import { AddVariantComponent } from './modules/admin/components/variants/add-variant/add-variant.component';
import { EditVariantComponent } from './modules/admin/components/variants/edit-variant/edit-variant.component';
import { AddBrandsComponent } from './modules/admin/components/brands/add-brands/add-brands.component';
import { EditBrandsComponent } from './modules/admin/components/brands/edit-brands/edit-brands.component';
import { AddCategoryComponent } from './modules/admin/components/categories/add-category/add-category.component';
import { EditCategoryComponent } from './modules/admin/components/categories/edit-category/edit-category.component';
import { UsersComponent } from './modules/admin/components/users/users/users.component';
import { AddUserComponent } from './modules/admin/components/users/add-user/add-user.component';
import { EditUserComponent } from './modules/admin/components/users/edit-user/edit-user.component';
import { ReservationsComponent } from './modules/admin/components/reservations/reservations/reservations.component';
import { MenuedaysComponent } from './modules/admin/components/menueDays/menuedays/menuedays.component';
import { OrdersComponent } from './modules/admin/components/orders/orders/orders.component';
import { GalleryComponent } from './modules/admin/components/gallery/gallery.component';
import { BannersManagementComponent } from './modules/admin/components/banners-management/banners-management.component';
import { SlidersManagementComponent } from './modules/admin/components/sliders-management/sliders-management.component';
import { DashboardStatsComponent } from './modules/admin/components/dashboard-stats/dashboard-stats.component';
import { BusinessSettingsComponent } from './modules/admin/components/business-settings/business-settings.component';
import { ClientGuard } from './core/auth/guards/client.guard';
import { LocationsComponent } from './modules/admin/components/Location/location/location.component';
// @formatter:off
/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
export const appRoutes: Route[] = [

    {path: '', pathMatch : 'full', redirectTo: 'home'},

    // Redirect signed-in user to the '/example'
    //
    // After the user signs in, the sign-in page will redirect the user to the 'signed-in-redirect'
    // path. Below is another redirection for that path to redirect the user to the desired
    // location. This is a small convenience to keep all main routes together here on this file.
    {path: 'signed-in-redirect', pathMatch : 'full', redirectTo: 'home'},

    // Auth routes for guests
    {
        path: '',
        canActivate: [NoAuthGuard],
        canActivateChild: [NoAuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'confirmation-required', loadChildren: () => import('app/modules/auth/confirmation-required/confirmation-required.routes')},
            {path: 'forgot-password', loadChildren: () => import('app/modules/auth/forgot-password/forgot-password.routes')},
            {path: 'reset-password', loadChildren: () => import('app/modules/auth/reset-password/reset-password.routes')},
            {path: 'sign-in', loadChildren: () => import('app/modules/auth/sign-in/sign-in.routes')},
            {path: 'sign-up', loadChildren: () => import('app/modules/auth/sign-up/sign-up.routes')}
        ]
    },

    // Auth routes for authenticated users
    {
        path: '',
        canActivate: [AuthGuard],
        canActivateChild: [AuthGuard],
        component: LayoutComponent,
        data: {
            layout: 'empty'
        },
        children: [
            {path: 'sign-out', loadChildren: () => import('app/modules/auth/sign-out/sign-out.routes')},
            {path: 'unlock-session', loadChildren: () => import('app/modules/auth/unlock-session/unlock-session.routes')}
        ]
    },

    // Landing routes
    // {
    //     path: '',
    //     component: LayoutComponent,
    //     data: {
    //         // layout: 'empty'
    //          layout: 'compact'

    //     },
    //     children: [
    //         {path: 'home', component:DashboardStatsComponent},
    //         // {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},
    //     ]
    // },

     // Admin routes for authenticated users
    {
  path: '',
  canActivate: [AuthGuard],
  canActivateChild: [AuthGuard],
  data: {
            layout: 'compact'
        },
  component: LayoutComponent,
  resolve: { initialData: initialDataResolver },
  children: [
            {path: 'home', component:DashboardStatsComponent},
            // {path: 'home', loadChildren: () => import('app/modules/landing/home/home.routes')},

    {
      path: 'admin',
      children: [
         {
      path: 'coupons',
      canActivate: [ClientGuard],
      loadChildren: () =>
        import('./modules/admin/components/coupons/coupon-admin.routes')
          .then(m => m.COUPON_ADMIN_ROUTES),
           data: {
                allowedClients: ['allinz','']
            }
    },
        {
        path: 'location',
        canActivate: [ClientGuard],
        loadComponent: () =>
            import('./modules/admin/components/Location/location/location.component')
            .then(component => component.LocationsComponent),

        data: {
            allowedClients: ['allinz','']
        }
        },
        { path: 'products', loadChildren: () => import('app/modules/admin/components/products/products/products.routes') },
        { path: 'categories', loadChildren: () => import('app/modules/admin/components/categories/categories/categories.routes') },
        { path: 'brands', loadChildren: () => import('app/modules/admin/components/brands/brands/brands.routes') },
        { path: 'units', loadChildren: () => import('app/modules/admin/components/units/units/units.routes') },
        { path: 'variants', loadChildren: () => import('app/modules/admin/components/variants/variants/variants.routes') },
        { path: 'users',component:UsersComponent },
        { path: 'add-user', component: AddUserComponent },
        { path: 'edit-user/:code', component: EditUserComponent },
        { path: 'add-product', component: AddProductComponent },
        { path: 'edit-product/:slug', component: EditProductComponent },
        { path: 'add-unit', component: AddUnitComponent },
        { path: 'edit-unit/:id', component: EditUnitComponent },
        { path: 'add-variant', component: AddVariantComponent },
        { path: 'edit-variant/:code', component: EditVariantComponent },
        { path: 'add-brand', component: AddBrandsComponent },
        { path: 'edit-brand/:slug', component: EditBrandsComponent },
        { path: 'add-category', component: AddCategoryComponent },
        { path: 'edit-category/:slug', component: EditCategoryComponent },
        { path: 'reservations', component: ReservationsComponent },
        // { path: 'MenuDays', component: MenuedaysComponent },
        { path: 'orders', component: OrdersComponent },
        { path: 'gallery', component: GalleryComponent },
        { path: 'sliders', component: SlidersManagementComponent },
        { path: 'banners', component: BannersManagementComponent },
        { path: 'business', component: BusinessSettingsComponent },
        
      ]
    },
            { 
                path: 'apps', 
                children: [
                            
                ]
            }
        ]
    },

    // 404 & Catch all
    { path: '404-not-found', pathMatch: 'full', loadChildren: () => import('app/modules/admin/pages/error/error-404/error-404.routes') },
    { path: '**', redirectTo: '404-not-found' }
];
